import React from 'react'
import { useSelector } from 'react-redux'

// Selectors
import {
  selectClientIsUnsubscribedFromCustomer,
} from 'src/store/selectors/client'

// Components
import { Page } from 'src/Components'
import ManagePreferences from './ManagePreferences'
import UnsubscribedFromCustomer from './UnsubscribedFromCustomer'

import styles from './PreferencesPanel.module.scss'

const PreferencesPanel = () => {
  const isUnsubscribedFromCustomer = useSelector(
    selectClientIsUnsubscribedFromCustomer
  )

  return (
    <Page>
      <Page.Body className={styles.body}>
        {!isUnsubscribedFromCustomer && <ManagePreferences />}
        {isUnsubscribedFromCustomer && <UnsubscribedFromCustomer />}
      </Page.Body>
    </Page>
  )
}

export default PreferencesPanel
